import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NotificationBannerHistory } from '../../../models/notification-banner.model';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-notification-banner-history',
  templateUrl: './notification-banner-history.component.html',
  styleUrls: ['./notification-banner-history.component.scss'],
  standalone: true,
  imports: [CommonModule, CommonSharedModule]
})
export class NotificationBannerHistoryComponent implements OnInit {
  loadingIcon = 'fa-circle-o-notch';
  notificationBannerHistory!: NotificationBannerHistory[];

  constructor(private osmService: OsmosisService) {}

  ngOnInit() {
    this.getBannerHistory(1);
  }

  getBannerHistory(programTypeId = 1) {
    this.osmService
      .getNotificationBannerHistory(programTypeId)
      .subscribe(response => {
        this.notificationBannerHistory = response;
      });
  }
}
